import { render, staticRenderFns } from "./QuatiConfirmation.vue?vue&type=template&id=7bc2fdf2"
import script from "./QuatiConfirmation.vue?vue&type=script&lang=js"
export * from "./QuatiConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports